import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class ProductInfoLinkResource extends BaseCamelCasedResource {
    pk() {
        return `${this.linkId}`;
    }
}
ProductInfoLinkResource.urlRoot = legacyApiResourceUrl("Product/GetAllProductInfoLinksForUser");
//# sourceMappingURL=ProductInfoLinkResource.js.map